/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { PropsWithChildren } from "react";
import styled, { css } from "styled-components";
import { theme } from "@nordcloud/gnui";

type ContainerProps = PropsWithChildren<{
  hasBorder?: boolean;
  justifyContent?: string;
  marginBottom?: string;
  width?: string;
}>;

type ContainerRowProps = {
  hasBorder?: boolean;
};

/* stylelint-disable no-descending-specificity */
function getBorderCss(showBorder: boolean) {
  return showBorder
    ? css`
        > div {
          border-right: 1px solid ${theme.color.border.border01};

          &:last-of-type {
            border: none;
          }
        }
      `
    : css`
        > div {
          border-right: none;
        }
      `;
}

const ContainerRow = styled.div<ContainerRowProps>`
  display: flex;
  flex-wrap: wrap;

  ${({ hasBorder }) => getBorderCss(hasBorder ?? false)};
`;

export function DataContainer({
  children,
  hasBorder = true,
  justifyContent = "flex-start",
  marginBottom = theme.spacing.spacing04,
  width,
}: ContainerProps) {
  return (
    <ContainerRow
      hasBorder={hasBorder}
      css={{ justifyContent, marginBottom, width }}
    >
      {children}
    </ContainerRow>
  );
}
